// // src/components/charting/CariogramTab.tsx
// import React, { useEffect, useState } from "react";
// import "../../css/CariogramTab.css";
// import { ChartingState } from "../../pages/DentalChartingScreen";
// import { useParams } from "react-router-dom";
// import api from "../../api/axiosConfig";
// import axios from "axios";

// interface CariogramTabProps {
//   chartingData: ChartingState;
//   onSubmitSuccess?: () => void;
// }

// const initialFormState: Record<string, string> = {
//   "1. Caries Experience": "",
//   "3. Diet Contents": "",
//   "4. Diet Frequency": "",
//   "6. Mutans Streptococci": "",
//   "7. Fluoride Program": "",
//   "8. Saliva Secretion": "",
//   "9. Buffer Capacity": "",
// };

// const CariogramTab: React.FC<CariogramTabProps> = ({
//   chartingData,
//   onSubmitSuccess,
// }) => {
//   const { emrNumber } = useParams<{ emrNumber: string }>();
//   const emrId = emrNumber;

//   const [formData, setFormData] = useState(initialFormState);
//   const [uploadedFile, setUploadedFile] = useState<File | null>(null);
//   const [riskScore, setRiskScore] = useState("");
//   const [likelihood, setLikelihood] = useState("");
//   const [cariogramS3Key, setCariogramS3Key] = useState<string | null>(null);
//   const [uploading, setUploading] = useState(false);

//   /* ------------------ INPUT HANDLER ------------------ */
//   const handleInputChange = (factor: string, value: string) => {
//     setFormData((prev) => ({ ...prev, [factor]: value }));
//   };

//   /* ------------------ MAPPERS ------------------ */

//   const mapDietContents = (value: string) =>
//     ({ "Class 1": "0", "Class 2": "1", "Class 3": "2", "Class 4": "3" })[
//       value
//     ] ?? "";

//   const mapMutansStreptococci = (value: string) =>
//     ({ "Class 0": "0", "Class 1": "1", "Class 2": "2", "Class 3": "3" })[
//       value
//     ] ?? "";

//   const mapSalivaSecretion = (value: string) =>
//     ({
//       Normal: "0",
//       "Mildly Low": "1",
//       "Moderately Low": "2",
//       "Severely Low": "3",
//     })[value] ?? "";

//   const mapBufferCapacity = (value: string) =>
//     ({ Adequate: "0", Reduced: "1", Low: "2" })[value] ?? "";

//   const mapFluorideProgram = (value: string) =>
//     ({
//       // "Fluoride paste + Regular use of other Fluoride products": "0",
//       // "Fluoride paste + Irregular use of other Fluoride products": "1",
//       // "Only Fluoride Toothpaste": "2",
//       // "No Fluoride toothpaste or products": "3",
//       "Fluoride paste + Regular use of other F products": "0",
//       "Fluoride toothpaste + Regular use of other Fluoride products": "0",

//       "Fluoride paste + Irregular use of other F products": "1",
//       "Fluoride toothpaste + Irregular use of other Fluoride products": "1",

//       "Only Fluoride Toothpaste": "2",
//       "Only fluoride toothpaste": "2",

//       "No Fluoride toothpaste or products": "3",
//       "No fluoride toothpaste or products": "3",
//     })[value] ?? "";

//   // ✅ NEW — Diet Frequency score is already numeric
//   const mapDietFrequencyScore = (value: number | undefined) =>
//     value !== undefined ? String(value) : "";

//   /* ------------------ FETCH DATA ------------------ */

//   useEffect(() => {
//     const fetchCariogram = async () => {
//       try {
//         const salivaRes = await api.dataCollectionApi.get(
//           `/api/forms/cariogram-saliva-details/${emrId}`,
//         );
//         const apiData = salivaRes.data?.data;
//         if (!apiData) return;

//         // ✅ NEW — Diet Frequency Scoring API

//         const dietFreqRes = await api.Questionnair.get(
//           `/api/scoring/scoresid/${emrId}/daily-diary?`,
//         );

//         // ✅ NEW — Fluoride Program API
//         const fluorideAnsRes = await api.Questionnair.get(
//           `/api/answers/getans/${emrId}`,
//           {
//             params: { category: "health" },
//           },
//         );

//         console.log("Daily Diary Full Response:", dietFreqRes.data);

//         const dailyDiaryData = dietFreqRes.data?.scores?.resultsById || {};

//         // console.log("Extracted Daily Diary:", dailyDiaryData);

//         const fluorideAnswers = fluorideAnsRes.data?.data?.[0]?.answers || [];

//         const fluorideAnswer = fluorideAnswers.find(
//           (a: any) => a.questionId === "DH_12",
//         );

//         const fluorideProgramValue = fluorideAnswer?.value || "";

//         const dietFrequencyScore =
//           dailyDiaryData["1128"] !== null &&
//           dailyDiaryData["1128"] !== undefined
//             ? String(dailyDiaryData["1128"])
//             : "";

//         const fluorideScore =
//           dailyDiaryData["1129"] !== null &&
//           dailyDiaryData["1129"] !== undefined
//             ? String(dailyDiaryData["1129"])
//             : "-";

//         setFormData((prev) => ({
//           ...prev,
//           "3. Diet Contents": mapDietContents(
//             apiData["Lactobacilli in Saliva"]?.[
//               "Lactobacilli – Diet and Carbohydrate Exposure Assessment"
//             ],
//           ),

//           "4. Diet Frequency": dietFrequencyScore,

//           "6. Mutans Streptococci": mapMutansStreptococci(
//             apiData["Streptococci Mutans in Saliva"]?.[
//               "Streptococci Mutans – Bacterial Load on Teeth"
//             ],
//           ),
//           // "7. Fluoride Program": fluorideScore,
//           "7. Fluoride Program": mapFluorideProgram(fluorideProgramValue),

//           "8. Saliva Secretion": mapSalivaSecretion(
//             apiData["Saliva Secretion Rate"]?.[
//               "Saliva Secretion – Stimulated Flow Rate per Minute"
//             ],
//           ),
//           "9. Buffer Capacity": mapBufferCapacity(
//             apiData["Saliva Buffer Capacity (pH)"]?.[
//               "Buffering Capacity – Dentobuff Color Result"
//             ],
//           ),
//         }));
//       } catch (err) {
//         console.error("Failed to fetch cariogram data", err);
//       }
//     };

//     fetchCariogram();
//   }, [emrId]);

//   /* ------------------ FILE UPLOAD ------------------ */

//   const handleFileChange = async (
//     event: React.ChangeEvent<HTMLInputElement>,
//   ) => {
//     if (!event.target.files?.[0]) return;

//     const file = event.target.files[0];
//     setUploadedFile(file);
//     setUploading(true);

//     try {
//       const presignRes = await api.dataCollectionApi.post("/api/s3/presign", {
//         id: emrId,
//         moduleName: "teledocs/cariogram-graph",
//         originalFilename: file.name,
//         contentType: file.type,
//         fileSize: file.size,
//       });

//       const { uploadUrl, key } = presignRes.data;

//       await axios.put(uploadUrl, file, {
//         headers: { "Content-Type": file.type },
//       });

//       setCariogramS3Key(key);
//       alert("PDF uploaded successfully");
//     } catch (err) {
//       console.error(err);
//       alert("Failed to upload PDF");
//     } finally {
//       setUploading(false);
//     }
//   };

//   /* ------------------ SUBMIT ------------------ */

//   const handleSubmit = async () => {
//     /* ------------------ VALIDATION ------------------ */

   
//     const cariesValue = formData["1. Caries Experience"];

//     if (!cariesValue) {
//       alert("Please select Caries Experience (0–3)");
//       return;
//     }

//     // 2. Cariogram PDF required
//     if (!cariogramS3Key) {
//       alert("Please upload Cariogram Graph PDF");
//       return;
//     }

//     // 3. Risk Score required
//     if (!riskScore) {
//       alert("Please select Cariogram Risk Score");
//       return;
//     }

//     // 4. ICCMS Risk & Likelihood required
//     if (!likelihood) {
//       alert("Please select ICCMS™ Caries Risk and Likelihood");
//       return;
//     }

   
//     const fluorideRaw = formData["7. Fluoride Program"];

//     try {
//       const payload = {
//         emrId,
//         chartType: "primary",
//         createdBy: "doctor_001",
//         cariogramIccmsData: {
//           table: {
//             cariesExperience: Number(formData["1. Caries Experience"]),
//             relatedDiseases: 0,
//             dietContents: Number(formData["3. Diet Contents"]),
//             dietFrequency: Number(formData["4. Diet Frequency"]),
//             plaqueAmount: 0,
//             mutansStreptococci: Number(formData["6. Mutans Streptococci"]),
//             // fluorideProgram: String(formData["7. Fluoride Program"]),
//             // fluorideProgram: formData["7. Fluoride Program"] ?? null,

//             fluorideProgram:
//               // !fluorideRaw || fluorideRaw === "-" ? null : fluorideRaw,
//               !fluorideRaw || fluorideRaw === "-" ? null : Number(fluorideRaw),

//             salivaSecretion: Number(formData["8. Saliva Secretion"]),
//             bufferCapacity: Number(formData["9. Buffer Capacity"]),
//             clinicalJudgement: 0,
//           },
//           cariogramGraph: cariogramS3Key,
//           cariogramRiskScore: riskScore,
//           iccmsRiskAndLikelihood: likelihood,
//         },
//       };

//       await api.dataCollectionApi.post(
//         "/api/teledocs/dental/cariogram",
//         payload,
//       );

//       if (onSubmitSuccess) {
//         onSubmitSuccess();
//       }

//       // alert("Cariogram + ICCMS saved successfully");
//     } catch (err) {
//       console.error(err);
//       alert("Failed to save cariogram ICCMS data");
//     }
//   };

//   /* ------------------------------------ */

//   return (
//     <div className="cariogram-container">
//       <p className="cariogram-description">
//         The following recommendations are targeted at preventing new lesions and
//         for existing lesions from advancing further. These recommendations are
//         based on the "Risk Status" and the "Age of the Child".
//       </p>

//       <div className="cariogram-main-content">
//         {/* Left Side: Input Table */}
//         <div className="cariogram-table-section">
//           <table className="cariogram-table">
//             <thead>
//               <tr>
//                 <th></th>
//                 <th>0</th>
//                 <th>1</th>
//                 <th>2</th>
//                 <th>3</th>
//                 <th>Dentist Input</th>
//               </tr>
//             </thead>
//             <tbody>
//               {/* Caries Experience */}
//               <tr>
//                 <td>
//                   <strong>1. Caries Experience</strong>
//                 </td>
//                 <td>Caries Free</td>
//                 <td>Better status than normal</td>
//                 <td>Normal for the age/area</td>
//                 <td>Worser status than normal</td>
//                 <td>
//                   <select
//                     value={formData["1. Caries Experience"]}
//                     onChange={(e) =>
//                       handleInputChange("1. Caries Experience", e.target.value)
//                     }
//                   >
//                     <option value="">Select</option>
//                     <option value="0">0</option>
//                     <option value="1">1</option>
//                     <option value="2">2</option>
//                     <option value="3">3</option>
//                   </select>
//                 </td>
//               </tr>
//               {/* Related Diseases */}
//               <tr>
//                 <td>
//                   <strong>2. Related Diseases</strong>
//                 </td>
//                 <td colSpan={4} className="text-muted">
//                   This factor is automatically calculated
//                 </td>
//                 <td>{/* <span className="auto-value">1</span> */}</td>
//               </tr>
//               {/* Diet Contents */}
//               <tr>
//                 <td>
//                   <strong>3. Diet Contents</strong>
//                 </td>
//                 <td>LB Class 1</td>
//                 <td>LB Class 2</td>
//                 <td>LB Class 3</td>
//                 <td>LB Class 4</td>
//                 <td>
//                   {/* <span className="auto-value">0</span> */}
//                   <input
//                     type="number"
//                     min="0"
//                     value={formData["3. Diet Contents"]}
//                     disabled
//                     onChange={(e) =>
//                       handleInputChange("3. Diet Contents", e.target.value)
//                     }
//                   />
//                 </td>
//               </tr>
//               {/* Diet Frequency */}
//               <tr>
//                 <td>
//                   <strong>4. Diet Frequency</strong>
//                 </td>
//                 <td>≤3 meals/Day</td>
//                 <td>4-5 meals/Day</td>
//                 <td>6-7 meals/Day</td>
//                 <td>&gt;7 meals/Day</td>
//                 <td>
//                   <input
//                     type="number"
//                     min="0"
//                     value={formData["4. Diet Frequency"]}
//                     disabled
//                     onChange={(e) =>
//                       handleInputChange("4. Diet Frequency", e.target.value)
//                     }
//                   />
//                 </td>
//               </tr>
//               {/* Plaque Amount */}
//               <tr>
//                 <td>
//                   <strong>5. Plaque Amount</strong>
//                 </td>
//                 <td colSpan={4} className="text-muted">
//                   This factor is automatically calculated
//                 </td>

//                 <td>{/* <span className="auto-value">1</span> */}</td>
//               </tr>
//               {/* Mutans Streptococci */}
//               <tr>
//                 <td>
//                   <strong>6. Mutans Streptococci</strong>
//                 </td>
//                 <td>SM Class 0</td>
//                 <td>SM Class 1</td>
//                 <td>SM Class 2</td>
//                 <td>SM Class 3</td>
//                 <td>
//                   <input
//                     type="number"
//                     min="0"
//                     value={formData["6. Mutans Streptococci"]}
//                     disabled
//                     onChange={(e) =>
//                       handleInputChange(
//                         "6. Mutans Streptococci",
//                         e.target.value,
//                       )
//                     }
//                   />
//                 </td>
//               </tr>
//               {/* Fluoride Program */}
//               <tr>
//                 <td>
//                   <strong>7. Fluoride Program</strong>
//                 </td>
//                 <td>Fluoride paste + Regular use of other Fluoride products</td>
//                 <td>
//                   Fluoride paste + Irregular use of other Fluoride products
//                 </td>
//                 <td>Only Fluoride Toothpaste</td>
//                 <td>No Fluoride Toothpaste or products</td>
//                 <td>
//                   <input
//                     type="text"
//                     value={formData["7. Fluoride Program"]}
//                     disabled
//                   />
//                 </td>
//               </tr>
//               {/* Saliva Secretion */}
//               <tr>
//                 <td>
//                   <strong>8. Saliva Secretion</strong>
//                 </td>
//                 <td>&gt;1.1 ml simulated saliva/min (Normal)</td>
//                 <td>0.9-1.1 ml simulated saliva/min (Mildly Low)</td>
//                 <td>0.5-0.9 ml simulated saliva/min (Moderately Low)</td>
//                 <td>&lt;0.5 ml simulated saliva/min (Severely Low)</td>
//                 <td>
//                   <input
//                     type="number"
//                     min="0"
//                     value={formData["8. Saliva Secretion"]}
//                     disabled
//                     onChange={(e) =>
//                       handleInputChange("8. Saliva Secretion", e.target.value)
//                     }
//                   />
//                 </td>
//               </tr>
//               {/* Buffer Capacity */}
//               <tr>
//                 <td>
//                   <strong>9. Buffer Capacity</strong>
//                 </td>
//                 <td>pH ≥ 6.0 (Adequate)</td>
//                 <td>pH 4.5-5.5 (Reduced)</td>
//                 <td>pH ≤ 4.0 (Low)</td>
//                 <td></td>
//                 <td>
//                   <input
//                     type="number"
//                     min="0"
//                     value={formData["9. Buffer Capacity"]}
//                     disabled
//                     onChange={(e) =>
//                       handleInputChange("9. Buffer Capacity", e.target.value)
//                     }
//                   />
//                 </td>
//               </tr>
//               {/* Clinical Judgement */}
//               <tr>
//                 <td>
//                   <strong>10. Clinical Judgement</strong>
//                 </td>
//                 <td colSpan={4} className="text-muted">
//                   This factor is automatically calculated
//                 </td>
//                 <td>{/* <span className="auto-value">2</span> */}</td>
//               </tr>
//             </tbody>
//           </table>
//         </div>

//         {/* Right Side: Risk Matrix */}
//         <div className="risk-matrix-section">
//           <h4>ICCMS™ Caries Risk & Likelihood Matrix</h4>
//           <p>Current Caries Activity Status at Patient Level</p>
//           <table className="risk-matrix-table">
//             <tbody>
//               <tr>
//                 <td></td>
//                 <td>
//                   <strong>No active caries lesions</strong>
//                 </td>
//                 <td>
//                   <strong>Initial stage active caries lesions</strong>
//                 </td>
//                 <td>
//                   <strong>Moderate or extensive active caries lesions</strong>
//                 </td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>Low Risk</strong>
//                 </td>
//                 <td className="green">Low likelihood</td>
//                 <td className="yellow">Moderate likelihood</td>
//                 <td className="red">High likelihood</td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>Moderate Risk</strong>
//                 </td>
//                 <td className="green">Low likelihood</td>
//                 <td className="yellow">Moderate likelihood</td>
//                 <td className="red">High likelihood</td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>High Risk</strong>
//                 </td>
//                 <td className="yellow">Moderate likelihood</td>
//                 <td className="red">High likelihood</td>
//                 <td className="red">High likelihood</td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Bottom Section */}
//       <div className="cariogram-footer">
//         <div className="footer-item">
//           <label>Cariogram Graph</label>
//           <div className="file-drop-area">
//             <input type="file" onChange={handleFileChange} />
//             <span>
//               {uploadedFile
//                 ? uploadedFile.name
//                 : "Drop your file here or browse"}
//             </span>
//           </div>
//         </div>
//         <div className="footer-item">
//           <label>Cariogram Risk Score</label>
//           <select
//             value={riskScore}
//             onChange={(e) => setRiskScore(e.target.value)}
//           >
//             <option value="">Select</option>
//             <option value="Low Risk">Low Risk</option>
//             <option value="Medium Risk">Medium Risk</option>
//             <option value="High Risk">High Risk</option>
//           </select>
//         </div>
//         <div className="footer-item">
//           <label>ICCMS™ Caries Risk and Likelihood</label>
//           <select
//             value={likelihood}
//             onChange={(e) => setLikelihood(e.target.value)}
//           >
//             <option value="">Select</option>
//             <option value="No Active">No Active</option>
//             <option value="Moderate">Moderate</option>
//             <option value="Intermediate/Extensive">
//               Intermediate/Extensive
//             </option>
//           </select>
//         </div>
//       </div>

//       <div className="submission-buttons">
//         <button
//           className="submit-btn"
//           onClick={handleSubmit}
//           disabled={uploading}
//         >
//           Submit
//         </button>

//         <button className="reset-btn">Reset</button>
//       </div>
//     </div>
//   );
// };

// export default CariogramTab;




// // src/components/charting/CariogramTab.tsx
// import React, { useEffect, useState } from "react";
// import "../../css/CariogramTab.css";
// import { ChartingState } from "../../pages/DentalChartingScreen";
// import { useParams } from "react-router-dom";
// import api from "../../api/axiosConfig";
// import axios from "axios";

// interface CariogramTabProps {
//   chartingData: ChartingState;
//   onSubmitSuccess?: () => void;
// }

// const initialFormState: Record<string, string> = {
//   "1. Caries Experience": "",
//   "2. Related Diseases": "",
//   "3. Diet Contents": "",
//   "4. Diet Frequency": "",
//   "5. Plaque Amount": "",
//   "6. Mutans Streptococci": "",
//   "7. Fluoride Program": "",
//   "8. Saliva Secretion": "",
//   "9. Buffer Capacity": "",
//   "10. Clinical Judgement": "",
// };

// const CariogramTab: React.FC<CariogramTabProps> = ({
//   chartingData,
//   onSubmitSuccess,
// }) => {
//   const { emrNumber } = useParams<{ emrNumber: string }>();
//   const emrId = emrNumber;

//   const [formData, setFormData] = useState(initialFormState);
//   const [uploadedFile, setUploadedFile] = useState<File | null>(null);
//   const [riskScore, setRiskScore] = useState("");
//   const [likelihood, setLikelihood] = useState("");
//   const [cariogramS3Key, setCariogramS3Key] = useState<string | null>(null);
//   const [uploading, setUploading] = useState(false);

//   /* ------------------ INPUT HANDLER ------------------ */
//   const handleInputChange = (factor: string, value: string) => {
//     setFormData((prev) => ({ ...prev, [factor]: value }));
//   };

//   /* ------------------ MAPPERS ------------------ */

//   const mapDietContents = (value: string) =>
//     ({ "Class 1": "0", "Class 2": "1", "Class 3": "2", "Class 4": "3" })[
//       value
//     ] ?? "";

//   const mapMutansStreptococci = (value: string) =>
//     ({ "Class 0": "0", "Class 1": "1", "Class 2": "2", "Class 3": "3" })[
//       value
//     ] ?? "";

//   const mapSalivaSecretion = (value: string) =>
//     ({
//       Normal: "0",
//       "Mildly Low": "1",
//       "Moderately Low": "2",
//       "Severely Low": "3",
//     })[value] ?? "";

//   const mapBufferCapacity = (value: string) =>
//     ({ Adequate: "0", Reduced: "1", Low: "2" })[value] ?? "";

//   const mapFluorideProgram = (value: string) =>
//     ({
//       "Fluoride paste + Regular use of other F products": "0",
//       "Fluoride toothpaste + Regular use of other Fluoride products": "0",

//       "Fluoride paste + Irregular use of other F products": "1",
//       "Fluoride toothpaste + Irregular use of other Fluoride products": "1",

//       "Only Fluoride Toothpaste": "2",
//       "Only fluoride toothpaste": "2",

//       "No Fluoride toothpaste or products": "3",
//       "No fluoride toothpaste or products": "3",
//     })[value] ?? "";

//   /* ------------------ FETCH DATA ------------------ */

//   useEffect(() => {
//     const fetchCariogram = async () => {
//       try {
//         const salivaRes = await api.dataCollectionApi.get(
//           `/api/forms/cariogram-saliva-details/${emrId}`,
//         );
//         const apiData = salivaRes.data?.data;
//         if (!apiData) return;

//         const dietFreqRes = await api.Questionnair.get(
//           `/api/scoring/scoresid/${emrId}/daily-diary?`,
//         );

//         const fluorideAnsRes = await api.Questionnair.get(
//           `/api/answers/getans/${emrId}`,
//           {
//             params: { category: "health" },
//           },
//         );

//         const dailyDiaryData = dietFreqRes.data?.scores?.resultsById || {};
//         const fluorideAnswers = fluorideAnsRes.data?.data?.[0]?.answers || [];
//         const fluorideAnswer = fluorideAnswers.find(
//           (a: any) => a.questionId === "DH_12",
//         );

//         const fluorideProgramValue = fluorideAnswer?.value || "";

//         const dietFrequencyScore =
//           dailyDiaryData["1128"] !== null &&
//           dailyDiaryData["1128"] !== undefined
//             ? String(dailyDiaryData["1128"])
//             : "";

//         setFormData((prev) => ({
//           ...prev,
//           "3. Diet Contents": mapDietContents(
//             apiData["Lactobacilli in Saliva"]?.[
//               "Lactobacilli – Diet and Carbohydrate Exposure Assessment"
//             ],
//           ),

//           "4. Diet Frequency": dietFrequencyScore,

//           "6. Mutans Streptococci": mapMutansStreptococci(
//             apiData["Streptococci Mutans in Saliva"]?.[
//               "Streptococci Mutans – Bacterial Load on Teeth"
//             ],
//           ),
//           "7. Fluoride Program": mapFluorideProgram(fluorideProgramValue),

//           "8. Saliva Secretion": mapSalivaSecretion(
//             apiData["Saliva Secretion Rate"]?.[
//               "Saliva Secretion – Stimulated Flow Rate per Minute"
//             ],
//           ),
//           "9. Buffer Capacity": mapBufferCapacity(
//             apiData["Saliva Buffer Capacity (pH)"]?.[
//               "Buffering Capacity – Dentobuff Color Result"
//             ],
//           ),
//         }));
//       } catch (err) {
//         console.error("Failed to fetch cariogram data", err);
//       }
//     };

//     fetchCariogram();
//   }, [emrId]);

//   /* ------------------ FILE UPLOAD ------------------ */

//   const handleFileChange = async (
//     event: React.ChangeEvent<HTMLInputElement>,
//   ) => {
//     if (!event.target.files?.[0]) return;

//     const file = event.target.files[0];
//     setUploadedFile(file);
//     setUploading(true);

//     try {
//       const presignRes = await api.dataCollectionApi.post("/api/s3/presign", {
//         id: emrId,
//         moduleName: "teledocs/cariogram-graph",
//         originalFilename: file.name,
//         contentType: file.type,
//         fileSize: file.size,
//       });

//       const { uploadUrl, key } = presignRes.data;

//       await axios.put(uploadUrl, file, {
//         headers: { "Content-Type": file.type },
//       });

//       setCariogramS3Key(key);
//       alert("PDF uploaded successfully");
//     } catch (err) {
//       console.error(err);
//       alert("Failed to upload PDF");
//     } finally {
//       setUploading(false);
//     }
//   };

//   /* ------------------ SUBMIT ------------------ */

//   const handleSubmit = async () => {
//     const cariesValue = formData["1. Caries Experience"];

//     if (!cariesValue) {
//       alert("Please select Caries Experience (0–3)");
//       return;
//     }

//     if (!cariogramS3Key) {
//       alert("Please upload Cariogram Graph PDF");
//       return;
//     }

//     if (!riskScore) {
//       alert("Please select Cariogram Risk Score");
//       return;
//     }

//     if (!likelihood) {
//       alert("Please select ICCMS™ Caries Risk and Likelihood");
//       return;
//     }

//     const parseNum = (val: string) => (val === "" || val === "-" ? 0 : Number(val));

//     try {
//       const payload = {
//         emrId,
//         chartType: "primary",
//         createdBy: "doctor_001",
//         cariogramIccmsData: {
//           table: {
//             cariesExperience: parseNum(formData["1. Caries Experience"]),
//             relatedDiseases: parseNum(formData["2. Related Diseases"]),
//             dietContents: parseNum(formData["3. Diet Contents"]),
//             dietFrequency: parseNum(formData["4. Diet Frequency"]),
//             plaqueAmount: parseNum(formData["5. Plaque Amount"]),
//             mutansStreptococci: parseNum(formData["6. Mutans Streptococci"]),
//             fluorideProgram: parseNum(formData["7. Fluoride Program"]),
//             salivaSecretion: parseNum(formData["8. Saliva Secretion"]),
//             bufferCapacity: parseNum(formData["9. Buffer Capacity"]),
//             clinicalJudgement: parseNum(formData["10. Clinical Judgement"]),
//           },
//           cariogramGraph: cariogramS3Key,
//           cariogramRiskScore: riskScore,
//           iccmsRiskAndLikelihood: likelihood,
//         },
//       };

//       await api.dataCollectionApi.post(
//         "/api/teledocs/dental/cariogram",
//         payload,
//       );

//       if (onSubmitSuccess) {
//         onSubmitSuccess();
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Failed to save cariogram ICCMS data");
//     }
//   };

//   /* ------------------------------------ */

//   return (
//     <div className="cariogram-container">
//       <p className="cariogram-description">
//         The following recommendations are targeted at preventing new lesions and
//         for existing lesions from advancing further. These recommendations are
//         based on the "Risk Status" and the "Age of the Child".
//       </p>

//       <div className="cariogram-main-content">
//         {/* Left Side: Input Table */}
//         <div className="cariogram-table-section">
//           <table className="cariogram-table">
//             <thead>
//               <tr>
//                 <th></th>
//                 <th>0</th>
//                 <th>1</th>
//                 <th>2</th>
//                 <th>3</th>
//                 <th>Dentist Input</th>
//               </tr>
//             </thead>
//             <tbody>
//               {/* 1. Caries Experience (Input Field) */}
//               <tr>
//                 <td>
//                   <strong>1. Caries Experience</strong>
//                 </td>
//                 <td>Caries Free</td>
//                 <td>Better status than normal</td>
//                 <td>Normal for the age/area</td>
//                 <td>Worser status than normal</td>
//                 <td>
//                   <select
//                     value={formData["1. Caries Experience"]}
//                     onChange={(e) =>
//                       handleInputChange("1. Caries Experience", e.target.value)
//                     }
//                   >
//                     <option value="">Select</option>
//                     <option value="0">0</option>
//                     <option value="1">1</option>
//                     <option value="2">2</option>
//                     <option value="3">3</option>
//                   </select>
//                 </td>
//               </tr>

//               {/* 2. Related Diseases (From Backend) */}
//               <tr>
//                 <td>
//                   <strong>2. Related Diseases</strong>
//                 </td>
//                 <td>No disease</td>
//                 <td>Disease/ Conditions, mild degree</td>
//                 <td>Severe degree, long-lasting</td>
//                 <td>NA</td>
//                 <td>
//                   <input
//                     type="number"
//                     min="0"
//                     value={formData["2. Related Diseases"]}
//                     disabled
//                   />
//                 </td>
//               </tr>

//               {/* 3. Diet Contents (From Backend) */}
//               <tr>
//                 <td>
//                   <strong>3. Diet Contents</strong>
//                 </td>
//                 <td>Very low fermentable carbohydrate</td>
//                 <td>Low fermentable carbohydrate, 'non-cariogenic' diet</td>
//                 <td>Moderate fermentable carbohydrate</td>
//                 <td>High fermentable carbohydrate intake inappropriate diet</td>
//                 <td>
//                   <input
//                     type="number"
//                     min="0"
//                     value={formData["3. Diet Contents"]}
//                     disabled
//                   />
//                 </td>
//               </tr>

//               {/* 4. Diet Frequency (From Backend) */}
//               <tr>
//                 <td>
//                   <strong>4. Diet Frequency</strong>
//                 </td>
//                 <td>≤ 3 Meals/ day</td>
//                 <td>4-5 Meals/ day</td>
//                 <td>6-7 Meals/ day</td>
//                 <td>&gt; 7 Meals/ day</td>
//                 <td>
//                   <input
//                     type="number"
//                     min="0"
//                     value={formData["4. Diet Frequency"]}
//                     disabled
//                   />
//                 </td>
//               </tr>

//               {/* 5. Plaque Amount (Input Field) */}
//               <tr>
//                 <td>
//                   <strong>5. Plaque Amount</strong>
//                 </td>
//                 <td>No plaque, all teeth surfaces are very clean.</td>
//                 <td>Accumulation of soft deposits, which can be seen with the naked eye.</td>
//                 <td></td>
//                 <td></td>
//                 <td>
//                   <select
//                     value={formData["5. Plaque Amount"]}
//                     onChange={(e) =>
//                       handleInputChange("5. Plaque Amount", e.target.value)
//                     }
//                   >
//                     <option value="">Select</option>
//                     <option value="0">0</option>
//                     <option value="1">1</option>
//                     <option value="2">2</option>
//                     <option value="3">3</option>
//                   </select>
//                 </td>
//               </tr>

//               {/* 6. Mutans Streptococci (From Backend) */}
//               <tr>
//                 <td>
//                   <strong>6. Mutans Streptococci</strong>
//                 </td>
//                 <td>SM Class 0</td>
//                 <td>SM Class 1</td>
//                 <td>SM Class 2</td>
//                 <td>SM Class 3</td>
//                 <td>
//                   <input
//                     type="number"
//                     min="0"
//                     value={formData["6. Mutans Streptococci"]}
//                     disabled
//                   />
//                 </td>
//               </tr>

//               {/* 7. Fluoride Program (From Backend) */}
//               <tr>
//                 <td>
//                   <strong>7. Fluoride Program</strong>
//                 </td>
//                 <td>Fluoride Toothpaste plus constant additional fluoride measures</td>
//                 <td>Fluoride toothpaste plus inadequate (infrequent) additional fluoride measures</td>
//                 <td>Fluoride Toothpaste Only</td>
//                 <td>Not using fluoride toothpaste or other fluoride measures</td>
//                 <td>
//                   <input
//                     type="number"
//                     min="0"
//                     value={formData["7. Fluoride Program"]}
//                     disabled
//                   />
//                 </td>
//               </tr>

//               {/* 8. Saliva Secretion (From Backend) */}
//               <tr>
//                 <td>
//                   <strong>8. Saliva Secretion</strong>
//                 </td>
//                 <td>Normal Saliva Secretion</td>
//                 <td>Low Saliva Secretion 0.9-1.1 ml simulated saliva/ min</td>
//                 <td>Low saliva secretion 0.5-0.9 ml simulated saliva/ min</td>
//                 <td>Very low saliva secretion, Xerostomia &lt;0.5 ml simulated saliva/ min</td>
//                 <td>
//                   <input
//                     type="number"
//                     min="0"
//                     value={formData["8. Saliva Secretion"]}
//                     disabled
//                   />
//                 </td>
//               </tr>

//               {/* 9. Buffer Capacity (From Backend) */}
//               <tr>
//                 <td>
//                   <strong>9. Buffer Capacity</strong>
//                 </td>
//                 <td>Adequate. Saliva end-pH ≥ 6.0</td>
//                 <td>Reduced. Saliva end-pH 4.5-5.5</td>
//                 <td>Low. Saliva end-pH ≤ 4.0</td>
//                 <td></td>
//                 <td>
//                   <input
//                     type="number"
//                     min="0"
//                     value={formData["9. Buffer Capacity"]}
//                     disabled
//                   />
//                 </td>
//               </tr>

//               {/* 10. Clinical Judgement (Input Field) */}
//               <tr>
//                 <td>
//                   <strong>10. Clinical Judgement</strong>
//                 </td>
//                 <td>Caries situation is more positive than what the Cariogram seems to indicate</td>
//                 <td>Caries situation points to the same risk as in the Cariogram.</td>
//                 <td>Caries situation is less than good compared to what the tests and the other factors seem to indicate.</td>
//                 <td>Caries situation is very bad. The examiner is very sure that caries will occur the coming year</td>
//                 <td>
//                   <select
//                     value={formData["10. Clinical Judgement"]}
//                     onChange={(e) =>
//                       handleInputChange("10. Clinical Judgement", e.target.value)
//                     }
//                   >
//                     <option value="">Select</option>
//                     <option value="0">0</option>
//                     <option value="1">1</option>
//                     <option value="2">2</option>
//                     <option value="3">3</option>
//                   </select>
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>

//         {/* Right Side: Risk Matrix & Caries Experience Reference Table */}
//         <div className="risk-matrix-section">
//           <h4>ICCMS™ Caries Risk & Likelihood Matrix</h4>
//           <p>Current Caries Activity Status at Patient Level</p>
//           <table className="risk-matrix-table">
//             <tbody>
//               <tr>
//                 <td></td>
//                 <td>
//                   <strong>No active caries lesions</strong>
//                 </td>
//                 <td>
//                   <strong>Initial stage active caries lesions</strong>
//                 </td>
//                 <td>
//                   <strong>Moderate or extensive active caries lesions</strong>
//                 </td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>Low Risk</strong>
//                 </td>
//                 <td className="green">Low likelihood</td>
//                 <td className="yellow">Moderate likelihood</td>
//                 <td className="red">High likelihood</td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>Moderate Risk</strong>
//                 </td>
//                 <td className="green">Low likelihood</td>
//                 <td className="yellow">Moderate likelihood</td>
//                 <td className="red">High likelihood</td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>High Risk</strong>
//                 </td>
//                 <td className="yellow">Moderate likelihood</td>
//                 <td className="red">High likelihood</td>
//                 <td className="red">High likelihood</td>
//               </tr>
//             </tbody>
//           </table>

//           {/* Caries Experience Reference Table Added Here */}
//           <div className="caries-reference-section" style={{ marginTop: "24px" }}>
//             <h4>Caries Experience Reference:</h4>
//             <table className="risk-matrix-table">
//               <thead>
//                 <tr>
//                   <th></th>
//                   <th>2 Years</th>
//                   <th>3 Years</th>
//                   <th>4 Years</th>
//                   <th>5 Years</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td><strong>0</strong></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                 </tr>
//                 <tr>
//                   <td><strong>1</strong></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                 </tr>
//                 <tr>
//                   <td><strong>2</strong></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                 </tr>
//                 <tr>
//                   <td><strong>3</strong></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Section */}
//       <div className="cariogram-footer">
//         <div className="footer-item">
//           <label>Cariogram Graph</label>
//           <div className="file-drop-area">
//             <input type="file" onChange={handleFileChange} />
//             <span>
//               {uploadedFile
//                 ? uploadedFile.name
//                 : "Drop your file here or browse"}
//             </span>
//           </div>
//         </div>
//         <div className="footer-item">
//           <label>Cariogram Risk Score</label>
//           <select
//             value={riskScore}
//             onChange={(e) => setRiskScore(e.target.value)}
//           >
//             <option value="">Select</option>
//             <option value="Low Risk">Low Risk</option>
//             <option value="Medium Risk">Medium Risk</option>
//             <option value="High Risk">High Risk</option>
//           </select>
//         </div>
//         <div className="footer-item">
//           <label>ICCMS™ Caries Risk and Likelihood</label>
//           <select
//             value={likelihood}
//             onChange={(e) => setLikelihood(e.target.value)}
//           >
//             <option value="">Select</option>
//             <option value="No Active">No Active</option>
//             <option value="Moderate">Moderate</option>
//             <option value="Intermediate/Extensive">
//               Intermediate/Extensive
//             </option>
//           </select>
//         </div>
//       </div>

//       <div className="submission-buttons">
//         <button
//           className="submit-btn"
//           onClick={handleSubmit}
//           disabled={uploading}
//         >
//           Submit
//         </button>

//         <button className="reset-btn">Reset</button>
//       </div>
//     </div>
//   );
// };

// export default CariogramTab;




// src/components/charting/CariogramTab.tsx
import React, { useEffect, useState } from "react";
import "../../css/CariogramTab.css";
import { ChartingState } from "../../pages/DentalChartingScreen";
import { useParams } from "react-router-dom";
import api from "../../api/axiosConfig";
import axios from "axios";

interface CariogramTabProps {
  chartingData: ChartingState;
  onSubmitSuccess?: () => void;
}

const initialFormState: Record<string, string> = {
  "1. Caries Experience": "",
  "2. Related Diseases": "",
  "3. Diet Contents": "",
  "3. Diet Contents Class": "",
  "4. Diet Frequency": "",
  "5. Plaque Amount": "",
  "6. Mutans Streptococci": "",
  "7. Fluoride Program": "",
  "8. Saliva Secretion": "",
  "9. Buffer Capacity": "",
  "10. Clinical Judgement": "",
};

const CariogramTab: React.FC<CariogramTabProps> = ({
  chartingData,
  onSubmitSuccess,
}) => {
  const { emrNumber } = useParams<{ emrNumber: string }>();
  const emrId = emrNumber;

  const [formData, setFormData] = useState(initialFormState);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [riskScore, setRiskScore] = useState("");
  const [likelihood, setLikelihood] = useState("");
  const [cariogramS3Key, setCariogramS3Key] = useState<string | null>(null);
  const [uploading, setUploading] = useState(false);

  /* ------------------ INPUT HANDLER ------------------ */
  const handleInputChange = (factor: string, value: string) => {
    setFormData((prev) => ({ ...prev, [factor]: value }));
  };

  /* ------------------ MAPPERS ------------------ */

  const mapDietContents = (value: string) =>
    ({ "Class 1": "0", "Class 2": "1", "Class 3": "2", "Class 4": "3" })[
      value
    ] ?? "";

  const mapMutansStreptococci = (value: string) =>
    ({ "Class 0": "0", "Class 1": "1", "Class 2": "2", "Class 3": "3" })[
      value
    ] ?? "";

  const mapSalivaSecretion = (value: string) =>
    ({
      Normal: "0",
      "Mildly Low": "1",
      "Moderately Low": "2",
      "Severely Low": "3",
    })[value] ?? "";

  const mapBufferCapacity = (value: string) =>
    ({ Adequate: "0", Reduced: "1", Low: "2" })[value] ?? "";

  const mapFluorideProgram = (value: string) =>
    ({
      "Fluoride paste + Regular use of other F products": "0",
      "Fluoride toothpaste + Regular use of other Fluoride products": "0",

      "Fluoride paste + Irregular use of other F products": "1",
      "Fluoride toothpaste + Irregular use of other Fluoride products": "1",

      "Only Fluoride Toothpaste": "2",
      "Only fluoride toothpaste": "2",

      "No Fluoride toothpaste or products": "3",
      "No fluoride toothpaste or products": "3",
    })[value] ?? "";

  /* ------------------ FETCH DATA ------------------ */

  useEffect(() => {
    const fetchCariogram = async () => {
      try {
        const salivaRes = await api.dataCollectionApi.get(
          `/api/forms/cariogram-saliva-details/${emrId}`,
        );
        const apiData = salivaRes.data?.data;
        if (!apiData) return;

        const dietFreqRes = await api.Questionnair.get(
          `/api/scoring/scoresid/${emrId}/daily-diary?`,
        );

        const fluorideAnsRes = await api.Questionnair.get(
          `/api/answers/getans/${emrId}`,
          {
            params: { category: "health" },
          },
        );

        const dailyDiaryData = dietFreqRes.data?.scores?.resultsById || {};
        const fluorideAnswers = fluorideAnsRes.data?.data?.[0]?.answers || [];
        const fluorideAnswer = fluorideAnswers.find(
          (a: any) => a.questionId === "DH_12",
        );

        const fluorideProgramValue = fluorideAnswer?.value || "";

        const dietFrequencyScore =
          dailyDiaryData["1128"] !== null &&
          dailyDiaryData["1128"] !== undefined
            ? String(dailyDiaryData["1128"])
            : "";

        const dietContentsRaw =
          apiData["Lactobacilli in Saliva"]?.[
            "Lactobacilli – Diet and Carbohydrate Exposure Assessment"
          ] || "";

        const mappedDietVal = mapDietContents(dietContentsRaw);

        setFormData((prev) => ({
          ...prev,
          "3. Diet Contents": mappedDietVal,
          "3. Diet Contents Class": mappedDietVal,
          "4. Diet Frequency": dietFrequencyScore,
          "6. Mutans Streptococci": mapMutansStreptococci(
            apiData["Streptococci Mutans in Saliva"]?.[
              "Streptococci Mutans – Bacterial Load on Teeth"
            ],
          ),
          "7. Fluoride Program": mapFluorideProgram(fluorideProgramValue),
          "8. Saliva Secretion": mapSalivaSecretion(
            apiData["Saliva Secretion Rate"]?.[
              "Saliva Secretion – Stimulated Flow Rate per Minute"
            ],
          ),
          "9. Buffer Capacity": mapBufferCapacity(
            apiData["Saliva Buffer Capacity (pH)"]?.[
              "Buffering Capacity – Dentobuff Color Result"
            ],
          ),
        }));
      } catch (err) {
        console.error("Failed to fetch cariogram data", err);
      }
    };

    fetchCariogram();
  }, [emrId]);

  /* ------------------ FILE UPLOAD ------------------ */

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (!event.target.files?.[0]) return;

    const file = event.target.files[0];
    setUploadedFile(file);
    setUploading(true);

    try {
      const presignRes = await api.dataCollectionApi.post("/api/s3/presign", {
        id: emrId,
        moduleName: "teledocs/cariogram-graph",
        originalFilename: file.name,
        contentType: file.type,
        fileSize: file.size,
      });

      const { uploadUrl, key } = presignRes.data;

      await axios.put(uploadUrl, file, {
        headers: { "Content-Type": file.type },
      });

      setCariogramS3Key(key);
      alert("PDF uploaded successfully");
    } catch (err) {
      console.error(err);
      alert("Failed to upload PDF");
    } finally {
      setUploading(false);
    }
  };

  /* ------------------ SUBMIT ------------------ */

  const handleSubmit = async () => {
    const cariesValue = formData["1. Caries Experience"];

    if (!cariesValue) {
      alert("Please select Caries Experience (0–3)");
      return;
    }

    if (!cariogramS3Key) {
      alert("Please upload Cariogram Graph PDF");
      return;
    }

    if (!riskScore) {
      alert("Please select Cariogram Risk Score");
      return;
    }

    if (!likelihood) {
      alert("Please select ICCMS™ Caries Risk and Likelihood");
      return;
    }

    const parseNum = (val: string) => (val === "" || val === "-" ? 0 : Number(val));

    try {
      const payload = {
        emrId,
        chartType: "primary",
        createdBy: "doctor_001",
        cariogramIccmsData: {
          table: {
            cariesExperience: parseNum(formData["1. Caries Experience"]),
            relatedDiseases: parseNum(formData["2. Related Diseases"]),
            dietContents: parseNum(
              formData["3. Diet Contents"] || formData["3. Diet Contents Class"]
            ),
            dietFrequency: parseNum(formData["4. Diet Frequency"]),
            plaqueAmount: parseNum(formData["5. Plaque Amount"]),
            mutansStreptococci: parseNum(formData["6. Mutans Streptococci"]),
            fluorideProgram: parseNum(formData["7. Fluoride Program"]),
            salivaSecretion: parseNum(formData["8. Saliva Secretion"]),
            bufferCapacity: parseNum(formData["9. Buffer Capacity"]),
            clinicalJudgement: parseNum(formData["10. Clinical Judgement"]),
          },
          cariogramGraph: cariogramS3Key,
          cariogramRiskScore: riskScore,
          iccmsRiskAndLikelihood: likelihood,
        },
      };

      await api.dataCollectionApi.post(
        "/api/teledocs/dental/cariogram",
        payload,
      );

      if (onSubmitSuccess) {
        onSubmitSuccess();
      }
    } catch (err) {
      console.error(err);
      alert("Failed to save cariogram ICCMS data");
    }
  };

  /* ------------------------------------ */

  return (
    <div className="cariogram-container">
      <p className="cariogram-description">
        The following recommendations are targeted at preventing new lesions and
        for existing lesions from advancing further. These recommendations are
        based on the "Risk Status" and the "Age of the Child".
      </p>

      <div className="cariogram-main-content">
        {/* Left Side: Input Table */}
        <div className="cariogram-table-section">
          <table className="cariogram-table cariogram-bordered-rows">
            <thead>
              <tr>
                <th></th>
                <th>0</th>
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>Dentist Input</th>
              </tr>
            </thead>
            <tbody>
              {/* 1. Caries Experience (Input Field) */}
              <tr>
                <td>
                  <strong>1. Caries Experience</strong>
                </td>
                <td>Caries Free</td>
                <td>Better status than normal</td>
                <td>Normal for the age/area</td>
                <td>Worser status than normal</td>
                <td>
                  <select
                    value={formData["1. Caries Experience"]}
                    onChange={(e) =>
                      handleInputChange("1. Caries Experience", e.target.value)
                    }
                  >
                    <option value="">Select</option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
              </tr>

              {/* 2. Related Diseases (From Backend) */}
              <tr>
                <td>
                  <strong>2. Related Diseases</strong>
                </td>
                <td>No disease</td>
                <td>Disease/ Conditions, mild degree</td>
                <td>Severe degree, long-lasting</td>
                <td>NA</td>
                <td>
                  <input
                    type="number"
                    min="0"
                    value={formData["2. Related Diseases"]}
                    disabled
                  />
                </td>
              </tr>

              {/* 3. Diet Contents (Single row with standardized split sections and continuous straight divider lines) */}
              <tr className="split-content-row">
                <td>
                  <strong>3. Diet Contents</strong>
                </td>
                <td>
                  <div className="uniform-split-cell">
                    <div className="split-top-content">Very low fermentable carbohydrate</div>
                    <div className="split-bottom-content">LB Class 1</div>
                  </div>
                </td>
                <td>
                  <div className="uniform-split-cell">
                    <div className="split-top-content">Low fermentable carbohydrate, 'non-cariogenic' diet</div>
                    <div className="split-bottom-content">LB Class 2</div>
                  </div>
                </td>
                <td>
                  <div className="uniform-split-cell">
                    <div className="split-top-content">Moderate fermentable carbohydrate</div>
                    <div className="split-bottom-content">LB Class 3</div>
                  </div>
                </td>
                <td>
                  <div className="uniform-split-cell">
                    <div className="split-top-content">High fermentable carbohydrate intake inappropriate diet</div>
                    <div className="split-bottom-content">LB Class 4</div>
                  </div>
                </td>
                <td>
                  <div className="uniform-split-cell">
                    <div className="split-top-content">
                      <input
                        type="number"
                        min="0"
                        value={formData["3. Diet Contents"]}
                        disabled
                      />
                    </div>
                    <div className="split-bottom-content">
                      <input
                        type="number"
                        min="0"
                        value={formData["3. Diet Contents Class"]}
                        disabled
                      />
                    </div>
                  </div>
                </td>
              </tr>

              {/* 4. Diet Frequency (From Backend) */}
              <tr>
                <td>
                  <strong>4. Diet Frequency</strong>
                </td>
                <td>≤ 3 Meals/ day</td>
                <td>4-5 Meals/ day</td>
                <td>6-7 Meals/ day</td>
                <td>&gt; 7 Meals/ day</td>
                <td>
                  <input
                    type="number"
                    min="0"
                    value={formData["4. Diet Frequency"]}
                    disabled
                  />
                </td>
              </tr>

              {/* 5. Plaque Amount (Input Field) */}
              <tr>
                <td>
                  <strong>5. Plaque Amount</strong>
                </td>
                <td>No plaque, all teeth surfaces are very clean.</td>
                <td>Accumulation of soft deposits, which can be seen with the naked eye.</td>
                <td></td>
                <td></td>
                <td>
                  <select
                    value={formData["5. Plaque Amount"]}
                    onChange={(e) =>
                      handleInputChange("5. Plaque Amount", e.target.value)
                    }
                  >
                    <option value="">Select</option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
              </tr>

              {/* 6. Mutans Streptococci (From Backend) */}
              <tr>
                <td>
                  <strong>6. Mutans Streptococci</strong>
                </td>
                <td>SM Class 0</td>
                <td>SM Class 1</td>
                <td>SM Class 2</td>
                <td>SM Class 3</td>
                <td>
                  <input
                    type="number"
                    min="0"
                    value={formData["6. Mutans Streptococci"]}
                    disabled
                  />
                </td>
              </tr>

              {/* 7. Fluoride Program (From Backend) */}
              <tr>
                <td>
                  <strong>7. Fluoride Program</strong>
                </td>
                <td>Fluoride Toothpaste plus constant additional fluoride measures</td>
                <td>Fluoride toothpaste plus inadequate (infrequent) additional fluoride measures</td>
                <td>Fluoride Toothpaste Only</td>
                <td>Not using fluoride toothpaste or other fluoride measures</td>
                <td>
                  <input
                    type="number"
                    min="0"
                    value={formData["7. Fluoride Program"]}
                    disabled
                  />
                </td>
              </tr>

              {/* 8. Saliva Secretion (From Backend) */}
              <tr>
                <td>
                  <strong>8. Saliva Secretion</strong>
                </td>
                <td>Normal Saliva Secretion</td>
                <td>Low Saliva Secretion 0.9-1.1 ml simulated saliva/ min</td>
                <td>Low saliva secretion 0.5-0.9 ml simulated saliva/ min</td>
                <td>Very low saliva secretion, Xerostomia &lt;0.5 ml simulated saliva/ min</td>
                <td>
                  <input
                    type="number"
                    min="0"
                    value={formData["8. Saliva Secretion"]}
                    disabled
                  />
                </td>
              </tr>

              {/* 9. Buffer Capacity (From Backend) */}
              <tr>
                <td>
                  <strong>9. Buffer Capacity</strong>
                </td>
                <td>Adequate. Saliva end-pH ≥ 6.0</td>
                <td>Reduced. Saliva end-pH 4.5-5.5</td>
                <td>Low. Saliva end-pH ≤ 4.0</td>
                <td></td>
                <td>
                  <input
                    type="number"
                    min="0"
                    value={formData["9. Buffer Capacity"]}
                    disabled
                  />
                </td>
              </tr>

              {/* 10. Clinical Judgement (Input Field) */}
              <tr>
                <td>
                  <strong>10. Clinical Judgement</strong>
                </td>
                <td>Caries situation is more positive than what the Cariogram seems to indicate</td>
                <td>Caries situation points to the same risk as in the Cariogram.</td>
                <td>Caries situation is less than good compared to what the tests and the other factors seem to indicate.</td>
                <td>Caries situation is very bad. The examiner is very sure that caries will occur the coming year</td>
                <td>
                  <select
                    value={formData["10. Clinical Judgement"]}
                    onChange={(e) =>
                      handleInputChange("10. Clinical Judgement", e.target.value)
                    }
                  >
                    <option value="">Select</option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Right Side: Risk Matrix & Caries Experience Reference Table */}
        <div className="risk-matrix-section">
          <h4>ICCMS™ Caries Risk & Likelihood Matrix</h4>
          <p>Current Caries Activity Status at Patient Level</p>
          <table className="risk-matrix-table">
            <tbody>
              <tr>
                <td></td>
                <td>
                  <strong>No active caries lesions</strong>
                </td>
                <td>
                  <strong>Initial stage active caries lesions</strong>
                </td>
                <td>
                  <strong>Moderate or extensive active caries lesions</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Low Risk</strong>
                </td>
                <td className="green">Low likelihood</td>
                <td className="yellow">Moderate likelihood</td>
                <td className="red">High likelihood</td>
              </tr>
              <tr>
                <td>
                  <strong>Moderate Risk</strong>
                </td>
                <td className="green">Low likelihood</td>
                <td className="yellow">Moderate likelihood</td>
                <td className="red">High likelihood</td>
              </tr>
              <tr>
                <td>
                  <strong>High Risk</strong>
                </td>
                <td className="yellow">Moderate likelihood</td>
                <td className="red">High likelihood</td>
                <td className="red">High likelihood</td>
              </tr>
            </tbody>
          </table>

          {/* Caries Experience Reference Table */}
          <div className="caries-reference-section" style={{ marginTop: "24px" }}>
            <h4>Caries Experience Reference:</h4>
            <table className="risk-matrix-table">
              <thead>
                <tr>
                  <th></th>
                  <th>2 Years</th>
                  <th>3 Years</th>
                  <th>4 Years</th>
                  <th>5 Years</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>0</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>1</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>2</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td><strong>3</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="cariogram-footer">
        <div className="footer-item">
          <label>Cariogram Graph</label>
          <div className="file-drop-area">
            <input type="file" onChange={handleFileChange} />
            <span>
              {uploadedFile
                ? uploadedFile.name
                : "Drop your file here or browse"}
            </span>
          </div>
        </div>
        <div className="footer-item">
          <label>Cariogram Risk Score</label>
          <select
            value={riskScore}
            onChange={(e) => setRiskScore(e.target.value)}
          >
            <option value="">Select</option>
            <option value="Low Risk">Low Risk</option>
            <option value="Medium Risk">Medium Risk</option>
            <option value="High Risk">High Risk</option>
          </select>
        </div>
        <div className="footer-item">
          <label>ICCMS™ Caries Risk and Likelihood</label>
          <select
            value={likelihood}
            onChange={(e) => setLikelihood(e.target.value)}
          >
            <option value="">Select</option>
            <option value="No Active">No Active</option>
            <option value="Moderate">Moderate</option>
            <option value="Intermediate/Extensive">
              Intermediate/Extensive
            </option>
          </select>
        </div>
      </div>

      <div className="submission-buttons">
        <button
          className="submit-btn"
          onClick={handleSubmit}
          disabled={uploading}
        >
          Submit
        </button>

        <button className="reset-btn">Reset</button>
      </div>
    </div>
  );
};

export default CariogramTab;